import type { components } from "@/features/search/api/schema";

/** Domain types re-exported from the generated OpenAPI schema. */
export type Product = components["schemas"]["Product"];
export type ProductImage = Product["images"][number];

export type Facet = components["schemas"]["Facet"];
export type TermsFacet = components["schemas"]["TermsFacet"];
export type TermsFacetValue = TermsFacet["values"][number];
export type RangeFacet = components["schemas"]["RangeFacet"];
/** A range the service says to render as one choice out of a list — discount, so far. */
export type ChoiceFacet = components["schemas"]["ChoiceFacet"];
export type ChoiceFacetValue = ChoiceFacet["values"][number];

export type Suggestion = components["schemas"]["Suggestion"];

export type PageInfo = components["schemas"]["PageInfo"];
export type ResultMeta = components["schemas"]["ResultMeta"];
/** The effective search recipe that ran — the page's own rules merged with the user's. */
export type AppliedRules = components["schemas"]["AppliedRules"];
export type Breadcrumb = components["schemas"]["Breadcrumb"];
/** SEO metadata for a curated landing page; `null` for a plain query search. */
export type ListingPageMeta = components["schemas"]["ListingPageMeta"];
/**
 * Where a result set sits in the category tree. Always present — a page with no category of
 * its own gets an empty `path` and the root categories as `children`.
 */
export type Taxonomy = components["schemas"]["Taxonomy"];
export type TaxonomyNode = components["schemas"]["TaxonomyNode"];

export const isTermsFacet = (facet: Facet): facet is TermsFacet =>
  facet.type === "terms";
export const isRangeFacet = (facet: Facet): facet is RangeFacet =>
  facet.type === "range";
export const isChoiceFacet = (facet: Facet): facet is ChoiceFacet =>
  facet.type === "choice";
